export const SET_RESERVATION_NUMBERS = 'SET_RESERVATION_NUMBERS'
export const RESET_RESERVATION_NUMBERS = 'RESET_RESERVATION_NUMBERS'
export const SET_AREA_CODES = 'SET_AREA_CODES'
export const RESET_AREA_CODES = 'RESET_AREA_CODES'